import { render } from "./ActiveWrapUps.vue?vue&type=template&id=c8bb72f2"
import script from "./ActiveWrapUps.vue?vue&type=script&lang=js"
export * from "./ActiveWrapUps.vue?vue&type=script&lang=js"

import "./ActiveWrapUps.vue?vue&type=style&index=0&id=c8bb72f2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__